function Content(props) {
    return (
        <div className="fade-in w-100" style={{paddingRight: 5, paddingLeft:5 }}>
            {props.children}
        </div>
    )
}

export default Content;